import React, { Component } from "react";
import { withRouter } from "../../utils/withRouter";
import { getAllRecipes,getReviews} from "../../api/api";
import "./Recipes.css";

class Recipes extends Component {
    constructor(props) {
        super(props);

        this.state = {
            recipes: [],
            loading: true,
            categoryName: "All",
        };
    }

    componentDidMount() {
        this.loadRecipes();
    }

    componentDidUpdate(prevProps) {
        if (
            prevProps.router.location.search !==
            this.props.router.location.search
        ) {
            this.loadRecipes();
        }
    }

    loadRecipes = async () => {
        const query = new URLSearchParams(
            this.props.router.location.search
        );

        const category_id = query.get("category_id");
        const category_name = query.get("category_name");

        const res = await getAllRecipes(category_id);

        const recipesWithRatings = await Promise.all(
            res.data.map(async (recipe) => {
                try {
                    const reviewRes = await getReviews(recipe.recipe_id);
                    const reviews = reviewRes.data;

                    const avg =
                        reviews.length > 0
                            ? reviews.reduce((acc, cur) => acc + cur.rating, 0) /
                            reviews.length
                            : 0;

                    return {
                        ...recipe,
                        avgRating: avg,
                        reviewCount: reviews.length,
                    };
                } catch (err) {
                    return {
                        ...recipe,
                        avgRating: 0,
                        reviewCount: 0,
                    };
                }
            })
        );

        this.setState({
            recipes: recipesWithRatings,
            categoryName: category_name || "All",
            loading: false,
        });
    };
    render() {
        const { recipes, loading, categoryName } = this.state;

        return (
            <section className="recipes-section">

                {/* ===== BIG HEADER ===== */}
                <div className="recipes-header">
                    <h1>
                        🍽️ Our Recipes - {categoryName}
                    </h1>
                </div>
                <div className="container-fluid py-5 services-section bg-light py-5 bottom-slant-gray">

                    <div className="container py-5">
                        <div className="row">

                            {loading && <p>Loading Recipes...</p>}

                            {!loading &&
                                recipes.map((item, index) => (
                                    <div className="col-md-6 p-0" key={index}>
                                        <div className="menu-tile d-lg-flex" onClick={() =>
                                            this.props.router.navigate(
                                                `/recipedetails/${item.recipe_id}`
                                            )
                                        }
                                            style={{ cursor: "pointer" }}>

                                            {/* TEXT SIDE */}
                                            <div
                                                className={`menu-text ${index % 2 === 0 ? "order-1" : "order-2"}`}
                                            >


                                                <h3>{item.recipe_title}</h3>

                                                <p className="menu-description">
                                                    {item.recipe_description.length > 110
                                                        ? item.recipe_description.substring(0, 110) + "..."
                                                        : item.recipe_description}
                                                </p>

                                                <p className="menu-oneline">
                                                    🍽️ Freshly crafted with authentic flavors
                                                </p>
                                                {/* ⭐ Average Rating */}
                                                <div className="recipe-rating">
                                                    <span className="stars">
                                                        {"★".repeat(Math.round(item.avgRating))}
                                                        {"☆".repeat(5 - Math.round(item.avgRating))}
                                                    </span>

                                                    <span className="review-count">
                                                        ({item.reviewCount} {item.reviewCount === 1 ? "Review" : "Reviews"})
                                                    </span>
                                                </div>
                                            </div>

                                            {/* IMAGE SIDE */}
                                            <div
                                                className={`menu-image-wrapper ${index % 2 === 0 ? "order-2" : "order-1"
                                                    }`}
                                            >
                                                <img
                                                    src={item.recipe_image}
                                                    alt={item.recipe_title}
                                                    className="menu-image"
                                                    onError={(e) => {
                                                        e.target.src =
                                                            "https://via.placeholder.com/600x400?text=Food+Image";
                                                    }}
                                                />
                                            </div>

                                        </div>
                                    </div>
                                ))}

                        </div>
                    </div>

                </div>
            </section>
        );
    }
}

export default withRouter(Recipes);